import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Root from './containers/App';
import configureStore from './store/configureStore';

const store = configureStore();

render(
  <Router>
    <Root store={store} />
  </Router>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/index.js